import { render, staticRenderFns } from "./ContactAddressTable.vue?vue&type=template&id=5a48eb26&"
import script from "./ContactAddressTable.vue?vue&type=script&lang=js&"
export * from "./ContactAddressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports